import { useLightMode } from '@/hooks/useLightMode'

import { Box, Text } from '@chakra-ui/react'

interface GridModalHeaderIProps {
  title?: string
  subtitle?: string
}

export const GridModalHeader = ({
  title = 'Camera Grids',
  subtitle = 'Configure camera grids to enable features such as Tailgating and AI Operator',
}: GridModalHeaderIProps) => {
  const mode = useLightMode()

  return (
    <Box alignItems='center' display='flex' mb={5}>
      <Box ml={2}>
        <Text color={`text.primary.${mode}`} fontSize='25px' fontWeight='bold'>
          {title}
        </Text>
        <Text color={`text.secondary.${mode}`} fontSize='14px' fontWeight={500}>
          {subtitle}
        </Text>
      </Box>
    </Box>
  )
}
